import * as React from 'react';
import { useAppSelector } from '../../store';
import { UserRole } from '../../store/auth';

export default function RoleGuard({ role, children }: { role: UserRole; children: React.ReactNode }) {
  const { role: userRole } = useAppSelector((state) => state.auth);

  function userHasPermission(requiredRole: UserRole): boolean {
      return requiredRole === userRole;
  }

  if (!userHasPermission(role as UserRole)) {
    return null;
  }

  return <>{children}</>;
}